import { render, staticRenderFns } from "./OrganismAddCredential.vue?vue&type=template&id=05f4e2f2&scoped=true&"
import script from "./OrganismAddCredential.vue?vue&type=script&lang=js&"
export * from "./OrganismAddCredential.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAddCredential.vue?vue&type=style&index=0&id=05f4e2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4e2f2",
  null
  
)

export default component.exports